//import '../../scss/master.scss';
import JQuery from 'jquery';
import 'nvsAccessTool';
// import VuduGdprPlugin from 'vuduGdpr';

// const gdprPlugin = new VuduGdprPlugin();
// gdprPlugin.init();

























$(document).ready(function () {

	// VuduGdprPlugin.init();



});







